var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import FileUpload from "~/components/common/file-upload.vue";
import { Dependencies } from "~/core/decorator";
import { CaseOperatorPageService } from "~/services/domain-service/case-operator-page.service";
import { Prop, Emit } from "vue-property-decorator";
import { CASE_CHANNEL, MENU_CHANNEL } from "~/config/enum.config";
import { namespace } from "vuex-class";
var CollectionExecutionModule = namespace("collection-execution");
var TelephoneActionArea = /** @class */ (function (_super) {
    __extends(TelephoneActionArea, _super);
    function TelephoneActionArea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fileList = [];
        _this.applyModel = {
            followupBack: "",
            followContent: "",
            checkTime: "",
            caseId: "",
            promiseAmt: "",
            targetPhone: "",
            targetName: "",
            custType: "",
            archiveNo: "",
            hasSync: undefined
        };
        _this.rules = {
            custType: [{ required: true, message: "请选择催收对象" }],
            followupBack: [{ required: true, message: "请选择行动代码" }],
            targetName: [{ required: true, message: "请输入姓名" }],
            targetPhone: [{ validator: _this.$validator.regex.phoneNumber }],
        };
        _this.submitLoading = false;
        _this.custTypeList = [];
        _this.selectedTarget = {};
        return _this;
    }
    TelephoneActionArea.prototype.emitSuccess = function () {
        this.submitLoading = false;
        this.$message.success("操作成功");
        this.reset();
    };
    TelephoneActionArea.prototype.getCustTypeList = function (e) {
        var _this = this;
        if (!e) {
            return;
        }
        this.caseOperatorPageService
            .personalContacts(this.caseId)
            .subscribe(function (data) {
            _this.custTypeList = data;
        });
    };
    TelephoneActionArea.prototype.custTypeChange = function (val) {
        this.applyModel.custType = val.custType;
        this.applyModel.targetName = val.contName;
        this.applyModel.targetPhone = val.phone;
    };
    TelephoneActionArea.prototype.reset = function () {
        var form = this.$refs["form"];
        this.applyModel.custType = "";
        this.selectedTarget = {};
        try {
            form.resetFields();
        }
        catch (error) {
            console.log('[telephone-action-area:(193)]:: ', error);
        }
    };
    TelephoneActionArea.prototype.submit = function () {
        var _this = this;
        var fileLists = this.fileList.map(function (item) {
            return item.response;
        });
        var form = this.$refs["form"];
        form.validate(function (result) {
            var _a;
            if (!result)
                return;
            if (_this.menuChannel === MENU_CHANNEL.Assist_tel) {
                _this.applyModel.assistId = _this.otherData.assistId;
            }
            _this.applyModel.caseId = _this.caseId;
            //FIXME [issue: 2026-03-24]添加 archiveNo 档案编号
            _this.applyModel.archiveNo = (_a = _this.topInfo) === null || _a === void 0 ? void 0 : _a.archiveNo;
            var params = __assign(__assign({}, _this.applyModel), { files: JSON.stringify(fileLists) });
            _this.submitLoading = true;
            _this.caseOperatorPageService
                .addCaseFollowupRecord(CASE_CHANNEL.tel, params)
                .subscribe(function (data) {
                _this.submitLoading = false;
                _this.emitSuccess();
                _this.fileList = [];
            }, function (err) {
                _this.submitLoading = false;
            });
        });
    };
    TelephoneActionArea.prototype.setCheckTime = function (val) { };
    TelephoneActionArea.prototype.onUploadRemove = function (file, fileList) {
        this.fileList = fileList;
    };
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], TelephoneActionArea.prototype, "caseOperatorPageService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], TelephoneActionArea.prototype, "caseId", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], TelephoneActionArea.prototype, "menuChannel", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], TelephoneActionArea.prototype, "otherData", void 0);
    __decorate([
        Prop()
    ], TelephoneActionArea.prototype, "topInfo", void 0);
    __decorate([
        Emit("success")
    ], TelephoneActionArea.prototype, "emitSuccess", null);
    TelephoneActionArea = __decorate([
        Component({
            components: {
                FileUpload: FileUpload,
            },
        })
    ], TelephoneActionArea);
    return TelephoneActionArea;
}(Vue));
export default TelephoneActionArea;
